export const product_routes = [
  {
    path: "/products",
    component: () => import("../Main.vue"),
    name: "Produtos"
  }
];

export default {};
